import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import MyCollapseContent from "./components/MyCollapseContent";

const MyCollapse = (props) => {
  const { data = [], isFaq = false, defaultOpen = "" } = props;

  const [openItem, setOpenItem] = useState(defaultOpen);

  const onSelectItem = (val) => {
    if (openItem === val) setOpenItem("");
    else setOpenItem(val);
  };

  return (
    <>
      {data.map((c, idx) => (
        <div
          key={c.value}
          className="border-b border-gray-border overflow-hidden"
        >
          <div
            className="bg-white md:py-8 py-[18px] px-2 flex justify-between items-center gap-4 cursor-pointer"
            onClick={() => onSelectItem(c.value)}
          >
            <p className={`2xl:text-2xl xl:text-xl md:text-lg font-semibold`}>
              <span className="text-[#5757ff] inline-block mr-3 2xl:text-2xl xl:text-xl md:text-lg font-bold">
                {!isFaq ? `${idx < 9 ? `0${idx + 1}` : idx + 1}` : "Q"}.
              </span>
              {c.title}
            </p>
            <button
              className="h-6 w-6 rounded flex items-center justify-center text-gray-dark"
              style={{
                transition: "all 0.2s ease",
              }}
            >
              <FontAwesomeIcon
                icon={faChevronDown}
                size="sm"
                style={{
                  transition: "all 0.2s ease",
                  transform:
                    openItem === c.value ? "rotate(180deg)" : "rotate(0deg)",
                }}
              />
            </button>
          </div>

          <MyCollapseContent item={c} openItem={openItem} />
        </div>
      ))}
    </>
  );
};

export default MyCollapse;
